<template>
  <div>
    <div class="coupon">
      <div style="text-align: center;margin-bottom: 1rem">
        <img style="width: 10rem;height: 10rem" :src="data.img" alt="图片" />
      </div>
      <div class="list">
        <div class="title">商家</div>
        <div class="content">{{ data.parking_store_name }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">名称</div>
        <div class="content">{{ data.name }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">金额</div>
        <div class="content">{{ data.fee }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">描述</div>
        <div class="content">{{ data.describe }}</div>
      </div>
      <van-divider />
      <div class="list">
        <div class="title">可用停车场</div>
        <div class="content">{{ data.parking_lot_name }}</div>
      </div>
    </div>
    <CarNumcoupon
      :show="show"
      @showBoxchange="showBoxchange"
      @getPlateLicense="getPlateLicense"
    />
    <div class="box" v-if="showBox"></div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { getCouponDetail, receiveCoupon } from '@/api/api';
import { Button, Toast, Divider } from 'vant';
import CarNumcoupon from '../components/CarNumcoupon';
export default {
  components: {
    VanDivider: Divider,
    CarNumcoupon,
  },
  data() {
    return {
      data: {},
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      total: 0,
      show: false,
      car_no: '',
      showBox: false,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  created() {
    this.handleGet();
  },
  methods: {
    showBoxchange(e) {
      console.log(e)
      this.showBox = e;
    },
    async handleGet() {
      try {
        const { data } = await getCouponDetail({
          parking_store_coupon_id: this.userInfo.parking_store_coupon_id,
        });
        this.data = data;
      } catch {}
    },
    async getPlateLicense(data, isRfid) {
      this.car_no = data;
      let { data: res } = await receiveCoupon({
        parking_store_coupon_id: this.userInfo.parking_store_coupon_id,
        car_no: this.car_no,
      });
      Toast('领取成功');
      this.$router.push({
        name: 'Home',
        query: {
          lot_id: res.lot_id,
        },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.coupon {
  background-color: #fff;
  padding: 1rem;
  margin-bottom: 0.5rem;
  .list {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    .title {
      width: 4rem;
      font-size: 0.8rem;
      margin-right: 1rem;
    }
    .content {
      flex: 1;
      font-size: 0.9rem;
    }
  }
}
.box{
  width: 100%;
  height: 303px;
  z-index: -13;
}
</style>
